<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <!-- <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="城市公司：">
              <el-input v-model="query.keyword" placeholder="请输入城市公司" clearable size="small" />
            </el-form-item>
          </el-form> -->
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <!-- <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div> -->
      <div class="nav-container">
        <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
        <!-- <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs> -->
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="城市公司" prop="cityName" align="center"></el-table-column>
          <el-table-column label="订货数" prop="sumCount" sortable align="center">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.sumCount }}</span>
              <el-button type="primary" size="mini" @click="toPages(row.cityId,1)">订货明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="余额/现金支付总价" prop="sumMoney" sortable align="center"></el-table-column>
          <el-table-column label="零售价支付总价" prop="xiaoduMoney" sortable align="center"></el-table-column>
          <el-table-column label="赠送支付总价" prop="tuitionMoney" sortable align="center"></el-table-column>
          <el-table-column label="秒杀数" prop="msPrice" sortable align="center" width="100">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.skillCount }}</span>
              <el-button type="primary" size="mini" @click="toPages(row.cityId,3)">订货明细</el-button>
            </template>
          </el-table-column>
          <el-table-column label="秒杀总价" prop="skillMoney" sortable align="center"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'

export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        sumCountSortSign: -1
        // isDisplay: 1,
        // keyword:'',
        // identity:''
      },
      selectItems: [],
      times: null,
      navList: [],
      navIndex: 0,
      today: ''
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    toPages(cityId, type) {
      let { timeStart, timeEnd } = this.times;
      this.$router.push({ path: '/order/goodsorder', query: { 'type': type, 'cityId': cityId, 'startTime': timeStart, 'endTime': timeEnd } })
    },
    handleDownload() {
      this.$router.push("/export/list?code=ExportCityCompanyTotalDownloadExcel")
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'sumCount': 'sumCountSortSign',
        'sumMoney': 'sumMoneySortSign',
        'xiaoduMoney': 'xiaoduMoneySortSign',
        'tuitionMoney': 'tuitionMoneySortSign',
        'skillCount': 'skillCountSortSign',
        'skillMoney': 'skillMoneySortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        startIndex: 1,
        pageSize: 10,
        sumCountSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      this.navIndex = index;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/sales/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      this.listLoading = true
      return cityCompanyApi.findCityCompanyTotalByPage(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
  }
}
</script>
<style scoped lang="scss">
.nav-container {
  display: flex;
  justify-content: flex-end;
}
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
